import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './ContactUs.css'

function ContactUs({headline, description, phoneImg, phone1, phone2, phone3, email, emailImg, addressImg, linkedin, linkedinImg, address, btnLabel}) {

    const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_8i3umzr', 'template_297s1zi', form.current, {
        publicKey: 'fxFtne_QnGc6sfDRQ',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
      e.target.reset();
  };

  return (
    <div className="contact-section" id='Contact'>
        <div className="container">
            <div className="contact-content">
                <div className="contact-text">
                    <h3 className="headline"> {headline} </h3>
                    <p className='text'>{description}</p>

                    <div className="contact-info">
                        <div className="phone">
                            <img src={phoneImg} alt="" />
                            <div>
                                <p className='text'>{phone1}</p>
                                <p className='text'>{phone2}</p>
                                <p className='text'>{phone3}</p>
                            </div>
                        </div>

                        <div className="email">
                            <img src={emailImg} alt="" />
                            <div>
                                <p className='text'>{email}</p>
                            </div>
                        </div>

                        <div className="address">
                            <img src={addressImg} alt="" />
                            <div>
                                <p className='text'>{address}</p>
                            </div>
                        </div>

                    </div>

                    <div className="social">
                    <h5>SOCIAL</h5>
                    <div className="linkedin">
                        <img src={linkedinImg} alt="" />
                        <div>
                        <a 
                        className="link" 
                        href="https://www.linkedin.com/company/alvac-company-limited/?originalSubdomain=ng" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        >
                        LinkedIn
                        </a>

                        </div>
                        </div>
                    </div>

                </div>
                <div className='contact-form'>
                   <form action="" ref={form} onSubmit={sendEmail}>

                    <div className="input-box">
                        <label htmlFor=""> Full Name </label>
                        <input type="text" className='field' name="name" placeholder='Enter your name' required />
                    </div>

                    <div className="input-box">
                        <label htmlFor=""> Email </label>
                        <input type="email" className='field' name="email" placeholder='Enter your email' required />
                    </div>

                    <div className="input-box">
                        <label htmlFor=""> Phone Number </label>
                        <input type="tel" name="number" className='field' placeholder='Enter your phone number' required />
                    </div>
                    

                    <div className="input-box">
                        <label htmlFor=""> Message</label>
                        <textarea name="message" id="" className='field-msg'  placeholder='Leave a message' required></textarea>
                    </div>

                    <button className='btn' type='submit'>Send Message</button>

                   </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ContactUs
